import { ENVIRONMENT_INITIALIZER, Provider, inject } from '@angular/core';
import { NZ_ICONS, NzIconModule } from 'ng-zorro-antd/icon';

import {
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  ThunderboltTwoTone,
  BankOutline,
  CloseCircleOutline,
  WarningOutline,
  SafetyCertificateOutline,
} from '@ant-design/icons-angular/icons';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleCheck, faCircleXmark, faPlugCircleBolt, faSquare } from '@fortawesome/free-solid-svg-icons';

const faIcons = [faSquare, faPlugCircleBolt, faCircleCheck, faCircleXmark, faCircleCheck, faCircleXmark];
const icons = [
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  FormOutline,
  ThunderboltTwoTone,
  BankOutline,
  CloseCircleOutline,
  WarningOutline,
  SafetyCertificateOutline,
];

export const ICON_IMPORTS = [
  NzIconModule,
  FontAwesomeModule,
];

export const ICON_PROVIDERS: Provider[] = [
  { provide: NZ_ICONS, useValue: icons },
  {
    provide: ENVIRONMENT_INITIALIZER,
    multi: true,
    useValue: () => {
      inject(FaIconLibrary).addIcons(...faIcons);
    },
  },
];
